import React, { useContext } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import './ViewershipTable.scss';
import ApplicationContext from 'components/Application/Context';
import { WatchApiContent, WatchApiProvider } from './WatchApiProvider';
import WatchFeedbackSurvey from './WatchFeedbackSurvey';

type ViewershipTableProps = {
  readonly watchSourceId: number;
  readonly benSourceId: number;
  readonly placementId?: number;
};

function ViewershipTable({
  watchSourceId,
  benSourceId,
  placementId,
}: ViewershipTableProps) {
  const { user, postHog } = useContext(ApplicationContext);

  const apolloClient = useApolloClient();

  return (
    <div className="viewership-table-container">
      <WatchApiProvider>
        <WatchApiContent
          watchSourceId={watchSourceId}
          benSourceId={benSourceId}
          placementId={placementId}
          benApolloClient={apolloClient}
          postHog={postHog}
          user={user}
        />
      </WatchApiProvider>
      <WatchFeedbackSurvey
        watchSourceId={watchSourceId}
        benSourceId={benSourceId}
        placementId={placementId}
      />
    </div>
  );
}

export default ViewershipTable;
